import api from "./api";

const NotiInAppTemplateAPI = {
    getAll: () => api.get(`/noti-inapp-template/all`),
    getById: (id) => api.get(`/noti-inapp-template/details/${id}`),
    update: (params) => api.post(`/noti-inapp-template/update`, params),
    delete: (params) => api.post(`/noti-inapp-template/delete`, params),
};

export default NotiInAppTemplateAPI;